export default function CentreApi({ makeRequest, buildRequest }) {
	function getCentres() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Centre'))
		);
	}

	function getMyCentres() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Centre/my-centres'))
		);
	}

	function getCentre(centreId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/centre/${centreId}`))
		).then((centre) => {
			if (!Array.isArray(centre?.documents)) return centre;
			return {
				...centre,
				documents: centre.documents.filter((document) => document?.documentTypeName?.toUpperCase() === 'FEES'),
			};
		});
	}

	function getCentreCalendar(centreId, date) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/centre/${centreId}/calendar`, { params: { date } }))
		);
	}

	function getCentreStaff(centreId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/centre/${centreId}/staff`))
		);
	}

	function getCentreDocumentFile(documentId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Centre/documents/${documentId}/file`, { responseType: 'blob' }))
		);
	}

	function updateCentreWaitlistTourStatus(centreId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/Centre/${centreId}/waitlist-tour-status`, payload))
		);
	}



	function upsertAvailability(centreId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Booking/${centreId}/availability`, payload))
		);
	}

	function upsertBlocked(centreId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Booking/${centreId}/blocked-recurring`, payload))
		);
	}

	function deleteAvailability(calendarAvailableRuleId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Booking/availability/${calendarAvailableRuleId}`))
		);
	}

	function deleteBlockedRecurring(calendarBlockedRecurringRuleId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Booking/blocked-recurring/${calendarBlockedRecurringRuleId}`))
		);
	}

	return {
		getCentres,
		getMyCentres,
		getCentre,
		getCentreCalendar,
		getCentreStaff,
		getCentreDocumentFile,
		updateCentreWaitlistTourStatus,
		upsertAvailability,
		upsertBlocked,
		deleteAvailability,
		deleteBlockedRecurring,
	};
}
